/*
 * Copyright (c) Nexign, JSC, 2022-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.19.0
 */

import isString from 'lodash/isString';

import TableTextBlock from '@/main/components/Table/components/TableColumns/TableTextBlock/TableTextBlock';

import { ICommonTranslation } from '../../../modules/internationalization/types';
import { TableCellNoValue } from '../../../modules/table';
import { ISubscriberTable } from '../types';

interface ITableSubscriberCellPersData {
    commonTranslation: ICommonTranslation,
    row: ISubscriberTable;
}

const TableSubscriberCellPersData = ({ commonTranslation, row }: ITableSubscriberCellPersData) => {

    const description = isString(row.persDataStatusDescription) ? row.persDataStatusDescription : '';
    const hintCode = isString(row.persDataHintCode) ? row.persDataHintCode : '';
    const defaultValue = commonTranslation.corporateTable.noValue;
    const noValue = commonTranslation.commonTable.noValueFilter;

    const hint = description
        || (hintCode && (commonTranslation.status.codes[hintCode] || commonTranslation.status.defaultMessage));

    if (!isString(row.persDataStatusName)) return <TableCellNoValue />

    return (
        <div className="table__personalStatus-text table__tooltip-text">
            {hint && (
                <div className="personal-data-hint" style={{ display: 'none' }}>{hint}</div>
            )}
            <TableTextBlock defaultValue={defaultValue} noValue={noValue}>
                {row.persDataStatusName}
            </TableTextBlock>
        </div>
    );
};

export default TableSubscriberCellPersData;
